"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addWorldCharacterEmote = void 0;
const Emote_1 = require("../classes/Emote");
const pixel_pigeon_1 = require("pixel-pigeon");
const WorldCharacter_1 = require("../classes/WorldCharacter");
const getConstants_1 = require("./getConstants");
const definables_1 = require("definables");
const addWorldCharacterEmote = (worldCharacterID, emoteID, usedAt) => {
    const constants = (0, getConstants_1.getConstants)();
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldCharacterID);
    if (worldCharacter.hasEmote()) {
        (0, pixel_pigeon_1.removeEntity)(worldCharacter.emote.entityID);
    }
    const emote = (0, definables_1.getDefinable)(Emote_1.Emote, emoteID);
    const sprites = [
        {
            spriteID: (0, pixel_pigeon_1.createSprite)({
                animationID: "default",
                animations: [
                    {
                        frames: [
                            {
                                height: constants["tile-size"],
                                sourceHeight: constants["tile-size"],
                                sourceWidth: constants["tile-size"],
                                sourceX: 0,
                                sourceY: 0,
                                width: constants["tile-size"],
                            },
                        ],
                        id: "default",
                    },
                ],
                imagePath: emote.backgroundImagePath,
            }),
        },
    ];
    if (emote.hasForegroundImagePath()) {
        sprites.push({
            spriteID: (0, pixel_pigeon_1.createSprite)({
                animationID: "default",
                animations: [
                    {
                        frames: [
                            {
                                height: constants["tile-size"],
                                sourceHeight: constants["tile-size"],
                                sourceWidth: constants["tile-size"],
                                sourceX: 0,
                                sourceY: 0,
                                width: constants["tile-size"],
                            },
                        ],
                        id: "default",
                    },
                ],
                imagePath: emote.foregroundImagePath,
            }),
        });
    }
    const entityID = (0, pixel_pigeon_1.createEntity)({
        height: constants["tile-size"],
        layerID: "emotes",
        levelID: worldCharacter.tilemapID,
        position: {
            x: worldCharacter.position.x * constants["tile-size"],
            y: worldCharacter.position.y * constants["tile-size"] -
                constants["tile-size"],
        },
        sprites,
        width: constants["tile-size"],
    });
    worldCharacter.emote = {
        entityID,
        usedAt,
    };
};
exports.addWorldCharacterEmote = addWorldCharacterEmote;
